import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-bottom: ", "px;\n  > strong { font-weight: 600 }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: ", "px ", "px;\n  bottom: 0;\n  left: 0;\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 1.14;\n  white-space: pre-wrap;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: ", "px 0;\n  text-decoration: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { typography, size, colors } from "../../../../shared/constants";
import { TertiaryLink } from "../../../TertiaryLink";
export var MenuCard = styled.a(_templateObject(), size.lg);
export var ImageWrapper = styled.div(_templateObject2(), size.xs2);
export var Image = styled.img(_templateObject3());
export var Label = styled.h5(_templateObject4(), size.md, size.sm, colors.white);
export var Description = styled.p(_templateObject5(), typography.bodyTextSmall, size.sm);
export var CTA = styled(TertiaryLink)(_templateObject6(), colors.green5);